import react from "react";
import Women from "./cultureImage/Women.jpg";
import Foundation from "./cultureImage/2025-1_Foundation_Day_01.jpg";
import ChristmasCelebration from "./cultureImage/ChristmasCelebration.jpg";
import Diwali from "./cultureImage/Celebration-7-year.jpg";
import GaneshUtsav from "./cultureImage/GaneshUtsav.jpg";
import MensDayCelebration from "./cultureImage/MensDayCelebration.jpg";
import WomensDay from "./cultureImage/Women’s.jpg";
import Holi from "./cultureImage/Holi .jpg";
import IndependenceDay from "./cultureImage/Independence .jpg";
import yogaDay from "./cultureImage/yoga.jpg";

const Celebrating = () => {
  return (
    <div className="font-recoleta pb-[24px]">
      <div className="bg-[#09588D] lg:px-14 pt-[10px] pb-[10px]">
        <h1
          data-aos="fade-up"
          className="text-[#F86F4B] 2xl:text-[38px] lg:text-[28px] text-[54px] font-bold px-14 text-center mt-12 font-recoleta"
        >
          {" "}
          Christmas Vibes at TekIT
        </h1>
        <div className="lg:flex mt-12">
          <div className="lg:w-[55%] content-center w-full p-4 font-recoleta text-white">
            <p
              data-aos="fade-right"
              className="2xl:text-[28px]  lg:text-[18px] text-[34px] space-y-10 "
            >
              We brought in the season with games, joy, and warmth.
            </p>
            <div data-aos="fade-left" className="mt-4">
              <p className="2xl:text-[28px] lg:text-[18px] text-[28px] font-semibold">
                Highlights of the day:
              </p>
              <ul className="list-disc ml-7 mt-2 space-y-1 text-[28px] lg:text-[18px] 2xl:text-[28px]">
                <li>Surprise visit by Santa</li>
                <li>Secret Santa & Santa Tambola</li>
                <li>“Guess the Item by Song” game</li>
                <li>Cozy office party and cherished memories</li>
              </ul>
          
 <p
                data-aos="fade-left"
                className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-4"
              >
Spreading joy, sharing warmth, and creating unforgettable moments.

              </p>
            </div>
          </div>
          <div className="lg:w-[45%] w-full">
            <img
              data-aos="fade-left"
              src={ChristmasCelebration}
              className=" w-full"
            />
          </div>
        </div>
      </div>
      <div className=" lg:px-14 pt-[10px] pb-[10px]">
        <h1
          data-aos="fade-up"
          className="text-[#F86F4B] 2xl:text-[38px] lg:text-[28px] text-[54px] font-bold px-14 text-center mt-12"
        >
          {" "}
        Diwali Dhamaka

        </h1>
       <div className="lg:flex mt-12">
  <div className="lg:w-[45%] w-full">
    <img src={Diwali} data-aos="fade-right" className="w-full" />
  </div>
  <div className="lg:w-[55%] content-center w-full p-4">
    <p data-aos="fade-left" className="2xl:text-[28px] lg:text-[18px] text-[28px]">
      This Diwali, our office sparkled with lights, laughter, and tradition.  
      From rituals to revelry, every moment brimmed with joy.
    </p>

    <ul className="mt-4 ml-4 list-disc space-y-2">
      <li data-aos="fade-left">Office Pooja for peace & prosperity</li>
      <li data-aos="fade-left">Chappan Bhog and festive treats</li>
      <li data-aos="fade-left">Traditional attire across the office</li>
      <li data-aos="fade-left">Colorful Rangoli and floral décor</li>
      <li data-aos="fade-left">Lights that transformed our space</li>
    </ul>

    <p data-aos="fade-left" className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-4">
      A day of smiles, good vibes, and festive cheer.
    </p>
  </div>
</div>

      </div>

      <div className="bg-[#09588D] lg:px-14 pt-[10px] pb-[10px]">
        <h1
          data-aos="fade-up"
          className="text-[#F86F4B] 2xl:text-[38px] lg:text-[28px] text-[54px] font-bold px-14 text-center mt-12"
        >
          {" "}
          Ganesh Utsav{" "}
        </h1>
       <div className="lg:flex mt-12">
  <div className="lg:w-[55%] content-center w-full p-4 text-white">
    <p data-aos="fade-right" className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-4">
      From Ganesh Sthapana to Visarjan, the next 10 days at TekIT will be filled with devotion, culture, and vibrant celebrations.
    </p>

    <p data-aos="fade-right" className="2xl:text-[22px] font-semibold lg:text-[14px] text-[22px] mt-4">
      Celebration Highlights:
    </p>

    <ul className="mt-2 ml-4 list-disc space-y-2">
      <li data-aos="fade-right">Daily themes to showcase creativity</li>
      <li data-aos="fade-right">Color codes to brighten the workplace</li>
      <li data-aos="fade-right">Prashad Seva with delicious treats</li>
      <li data-aos="fade-right">Aarti and Bhajans to start the day with devotion</li>
    </ul>

    <p data-aos="fade-right" className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-4">
      Let’s welcome Ganpati Bappa with open hearts and celebrate as one family.
    </p>

    <p data-aos="fade-right" className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-2 font-semibold">
      Ganpati Bappa Morya! Mangal Murti Morya!
    </p>
  </div>

  <div className="lg:w-[45%] w-full">
    <img src={GaneshUtsav} data-aos="fade-left" className="p-4 w-full" />
  </div>
</div>

      </div>
      <div className=" lg:px-14 pt-[10px] pb-[10px]">
        <h1
          data-aos="fade-up"
          className="text-[#F86F4B] 2xl:text-[38px] lg:text-[28px] text-[54px] font-bold px-14 text-center mt-12"
        >
          {" "}
        Men’s Day Celebration!{" "}
        </h1>
      <div className="lg:flex mt-12">
  <div className="lg:w-[45%] w-full">
    <img
      data-aos="fade-right"
      src={MensDayCelebration}
      className="w-full"
    />
  </div>

  <div className="lg:w-[55%] content-center w-full p-4">
    <p data-aos="fade-left" className="2xl:text-[28px] lg:text-[18px] text-[28px]">
      A big appreciation to our incredible male colleagues.
    </p>

    <p data-aos="fade-left" className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-4">
      Our ladies made Men’s Day memorable with heartfelt handwritten notes and a celebration filled with laughter, energy, and joy.
    </p>

    <p data-aos="fade-left" className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-4">
      From meaningful messages to cheerful moments, the day reflected how much we value the dedication, positivity, and presence our male teammates bring every day.
    </p>

    <p data-aos="fade-left" className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-4">
      Thank you for being your best selves and making our workplace complete.
    </p>
  </div>
</div>

      </div>

      <div className="bg-[#09588D] lg:px-14 pt-[10px] pb-[10px]">
        <h1
          data-aos="fade-up"
          className="text-[#F86F4B] 2xl:text-[38px] lg:text-[28px] text-[54px] font-bold px-8 text-center mt-12"
        >
           International Women’s Day{" "}
        </h1>
        <div className="lg:flex mt-12">
  <div className="lg:w-[55%] content-center w-full p-4 text-white">
    <p data-aos="fade-right" className="2xl:text-[28px] lg:text-[18px] text-[28px]">
      This 8th March, we celebrated International Women’s Day by honoring the women who inspire, lead, and create change every day.
    </p>

    <p data-aos="fade-right" className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-4">
      The day focused on women’s health, recognized achievements, and promoted equality — because empowered women empower the world.
    </p>

    <p data-aos="fade-right" className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-4">
      Our male colleagues added a thoughtful touch with celebrations, sweet treats, and heartfelt appreciation.
    </p>

    <p data-aos="fade-right" className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-4">
      Here’s to celebrating womanhood — today and always.
    </p>
  </div>

  <div className="lg:w-[45%] w-full">
    <img src={WomensDay} data-aos="fade-left" className="w-full" />
  </div>
</div>

      </div>

      <div className=" lg:px-14 pt-[10px] pb-[10px]">
        <h1
          data-aos="fade-up"
          className="text-[#F86F4B] 2xl:text-[38px] lg:text-[28px] text-[54px] font-bold px-14 text-center mt-12"
        >
          Holi celebration{" "}
        </h1>
  <div className="lg:flex mt-12">
  <div className="lg:w-[45%] w-full">
    <img data-aos="fade-left" src={Holi} className="w-full" />
  </div>

  <div className="lg:w-[55%] content-center w-full p-4">
    <p data-aos="fade-right" className="2xl:text-[28px] lg:text-[18px] text-[28px]">
      Holi at TekIT was filled with joy, color, and energy — from playful gulal moments to dancing under the open sky.
    </p>

    <p data-aos="fade-right" className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-4">
      Traditional delicacies like gujiyas, samosas, and thandai added flavor to the festivities, making the day even more special.
    </p>

    <p data-aos="fade-right" className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-4">
      Laughter, music, and shared moments turned the celebration into a perfect blend of tradition and togetherness.
    </p>
  </div>
</div>

      </div>
      <div className="bg-[#09588D] lg:px-14 pt-[10px] pb-[10px]">
        <h1
          data-aos="fade-up"
          className="text-[#F86F4B] 2xl:text-[38px] lg:text-[28px] text-[54px] font-bold px-14 text-center mt-12"
        >
          The Independence Day and Republic Day
        </h1>
     <div className="lg:flex mt-12">
  <div className="lg:w-[55%] content-center w-full p-4 text-white">
    <p data-aos="fade-right" className="2xl:text-[22px] lg:text-[14px] text-[28px]">
      We came together to celebrate our nation with pride and gratitude.
    </p>

    <p data-aos="fade-right" className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-4">
      The day began with the flag hoisting and National Anthem — a heartfelt tribute to our heroes.
    </p>

    <p data-aos="fade-right" className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-4">
      Dressed in tricolor, we enjoyed tasty treats, fun games, and cheerful moments that brought everyone closer.
    </p>

    <p data-aos="fade-right" className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-2">
      A beautiful reminder of unity, culture, and the joy of being Indian. Jai Hind!
    </p>
  </div>

  <div className="lg:w-[45%] w-full">
    <img data-aos="fade-left" src={IndependenceDay} className="w-full" />
  </div>
</div>

      </div>
      <div className=" lg:px-14 pt-[10px] pb-[10px]">
        <h1
          data-aos="fade-up"
          className="text-[#F86F4B] 2xl:text-[38px] lg:text-[28px] text-[54px] font-bold px-14 text-center mt-12"
        >
          {" "}
          International Day of Yoga{" "}
        </h1>
       <div className="lg:flex mt-12">
  <div className="lg:w-[45%] w-full">
    <img data-aos="fade-right" src={yogaDay} className="p-4 w-full" />
  </div>
  <div className="lg:w-[55%] content-center w-full p-4">
    <p data-aos="fade-left" className="2xl:text-[28px] lg:text-[18px] text-[28px]">
      Breathe. Stretch. Smile.
    </p>

    <p data-aos="fade-left" className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-1">
      To honor the essence of wellness and mindfulness, we celebrated International Day of Yoga with a rejuvenating Yoga Session right here at our office.
    </p>

    <p data-aos="fade-left" className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-1">
      We invited a professional Yoga Trainer who guided us through a series of energizing and calming yoga techniques — a much-needed pause from our busy schedules.
    </p>

    <p data-aos="fade-left" className="2xl:text-[22px] font-semibold lg:text-[20px] text-[28px] mt-1">
      It was the perfect opportunity to:
    </p>

    <ul className="list-disc ml-8 mt-2 space-y-1 text-[28px] lg:text-[18px] 2xl:text-[28px]">
      <li>Stretch and move</li>
      <li>De-stress and recharge</li>
      <li>Boost energy and focus at work</li>
      <li>Improve posture and flexibility</li>
      <li>Reduce stress and anxiety</li>
      <li>Reignite focus and productivity</li>
    </ul>

    <p data-aos="fade-left" className="2xl:text-[28px] lg:text-[18px] text-[28px] mt-4">
      The session left us feeling refreshed, recharged, and more connected — mind, body, and soul.
    </p>
  </div>
</div>

      </div>
    </div>
  );
};
export default Celebrating;
